import { Svg, Path } from '../_Svg';
import type { IconComponent } from '..';
import useIconProps from '../useIconProps';
import { assignWithoutSideEffects } from '~utils/assignWithoutSideEffects';

const _CheckCircleIcon: IconComponent = ({ size, color, ...styledProps }) => {
  const { height, width, iconColor } = useIconProps({ size, color });

  return (
    <Svg {...styledProps} width={width} height={height} viewBox="0 0 24 24" fill="none">
      <Path
        d="M4.15845 7.14673C6.74812 4.11682 11.0222 3.15114 14.663 4.77337C15.1675 4.99815 15.7586 4.77141 15.9834 4.26694C16.2082 3.76247 15.9815 3.17129 15.477 2.94651C11.0272 0.963789 5.80325 2.14407 2.6381 5.84729C-0.527049 9.55051 -0.879431 14.8945 1.77205 18.9813C4.42353 23.0681 9.44725 24.9241 14.1189 23.5428C18.7905 22.1615 21.9972 17.8715 22 12.9999V12.0699C22 11.5177 21.5523 11.0699 21 11.0699C20.4477 11.0699 20 11.5177 20 12.0699V12.9994C19.9977 16.9852 17.3741 20.4948 13.5518 21.6249C9.72957 22.755 5.61926 21.2364 3.44986 17.8927C1.28047 14.549 1.56878 10.1766 4.15845 7.14673Z"
        fill={iconColor}
      />
      <Path
        d="M22.7071 4.70705C23.0976 4.31652 23.0976 3.68336 22.7071 3.29283C22.3166 2.90231 21.6834 2.90231 21.2929 3.29283L11 13.5857L8.70711 11.2928C8.31658 10.9023 7.68342 10.9023 7.29289 11.2928C6.90237 11.6834 6.90237 12.3165 7.29289 12.707L10.2929 15.707C10.6834 16.0976 11.3166 16.0976 11.7071 15.707L22.7071 4.70705Z"
        fill={iconColor}
      />
    </Svg>
  );
};

const CheckCircleIcon = assignWithoutSideEffects(_CheckCircleIcon, {
  componentId: 'CheckCircleIcon',
});

export default CheckCircleIcon;
